// Stringified modifier types (as stored in the CookedEvent).
// Keep in sync with the enum for these in schema.go
export const DEAD_CLICK = '0';
export const RAGE_CLICK = '1';
export const ERROR_CLICK = '2';
export const SUSPICIOUS_EVENT = '3';
export const SENTIMENT_EVENT = '4';
export const LONG_CLICK = '5';
export const UNHANDLED_CLICK = '6';
